"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_native_svg_1 = __importStar(require("react-native-svg"));
function SvgComponent(props) {
    return (React.createElement(react_native_svg_1.default, Object.assign({ width: 13, height: 15, viewBox: "0 0 13 15", fill: "#4F4F4F" }, props),
        React.createElement(react_native_svg_1.Path, { d: "M11.096 1.858A6.538 6.538 0 006.5 0C4.764 0 3.132.66 1.904 1.858A6.226 6.226 0 000 6.344c0 3.428 3.321 6.28 5.105 7.811.248.213.462.397.633.553.214.194.488.292.762.292.275 0 .549-.098.763-.292.17-.156.385-.34.632-.553 1.785-1.532 5.106-4.383 5.106-7.81a6.23 6.23 0 00-1.905-4.487zM7.3 13.496c-.253.217-.472.405-.652.57a.221.221 0 01-.296 0c-.18-.165-.4-.353-.653-.57C4.022 12.056.9 9.375.9 6.344.9 3.33 3.412.88 6.5.88c3.088 0 5.6 2.451 5.6 5.465 0 3.031-3.122 5.712-4.8 7.152z" }),
        React.createElement(react_native_svg_1.Path, { d: "M6.5 3.309c-1.58 0-2.864 1.254-2.864 2.796C3.636 7.646 4.92 8.9 6.5 8.9c1.58 0 2.864-1.254 2.864-2.795 0-1.542-1.285-2.796-2.864-2.796zm0 4.712c-1.083 0-1.964-.86-1.964-1.917S5.417 4.187 6.5 4.187s1.964.86 1.964 1.917S7.583 8.021 6.5 8.021z" }),
        React.createElement(react_native_svg_1.Defs, null,
            React.createElement(react_native_svg_1.ClipPath, { id: "prefix__clip0" },
                React.createElement(react_native_svg_1.Path, { fill: "#fff", d: "M0 0h13v15H0z" })))));
}
exports.default = SvgComponent;
